import React from 'react';

const Footer = () => (
  <div className='mt-24'>
    <p className='dark:text-gray-200 text-gray-700 text-center  absolute bottom-5 left-0 right-0 '>
      © 2022 All rights reserved by irshad alam
    </p>
  </div>
);

export default Footer;
